module.exports = "/_next/static/images/hachigoramen-27508a2a9f5f338dab089dcdd804eaf9.jpg";